import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Transfer } from "../../transfers.types";
import {
  CancelTransferPayload,
  requestCancelTransfer,
} from "./cancelTransfer.request";

const useCancelTransfer = (
  options?: MutationOptions<
    Transfer,
    ApiServiceError<ApiError>,
    CancelTransferPayload
  >,
) => {
  return useMutation({
    mutationFn: requestCancelTransfer,
    onError: toastServerError,
    ...options,
  });
};

export default useCancelTransfer;
